import { Component, EventEmitter, Output, ViewChild, ChangeDetectionStrategy, signal } from '@angular/core';
import { Grid, GridActionIconClickEvent, GridHyperlinkClickEvent } from '@inavista/components/grid';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import { exportInavistaGrid } from 'projects/service/src/app/shared/utils/inavista-grid-export';
import { CYCLE_COUNT_EXCEPTIONS_GRID_CONFIG, OPEN_EXCEPTION_ICON } from './cycle-counts-exception-popup.grid.config';

// "Cycle Count Warehouses with Open Exceptions", opened by the home page at sign-in when there are any.
// Eager, not OnPush: it hosts the old cycle count popup (Eager, not migrated), whose HTTP results would never be
// drawn under an OnPush parent (empty header and a spinner until the next click).
@Component({
    selector: 'app-cycle-counts-exception-popup',
    templateUrl: './cycle-counts-exception-popup.component.html',
    styleUrls: ['./cycle-counts-exception-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CycleCountExceptionPopupComponent {

  @Output() onClose = new EventEmitter();

  @ViewChild('cycleCountExceptionPopupGrid') grid: Grid;

  readonly gridConfig = CYCLE_COUNT_EXCEPTIONS_GRID_CONFIG;
  readonly actionIcons = [OPEN_EXCEPTION_ICON];
  readonly cycleCountId = signal<string | null>(null);
  // As before, the popup opens in its smaller size.
  isExpanded = false;

  constructor(private commonService: CommonService) {}

  onHyperlinkClick(event: GridHyperlinkClickEvent) {
    this.cycleCountId.set((event.row as any).cycleCountId);
  }

  onActionIconClick(event: GridActionIconClickEvent) {
    if (event.iconKey === 'openException') this.cycleCountId.set((event.row as any).cycleCountId);
  }

  // Same file name as before: "Cycle count with exceptions(<date>).xlsx".
  onExportRequested() {
    exportInavistaGrid(this.grid, 'Cycle count with exceptions');
  }

  close() {
    this.commonService.showConfirmation('Are you sure to close?')
      .then(result => {
        if (result.isConfirmed) this.onClose.emit();
      });
  }
}
